import { createPaywallApi } from '@forest/paywall-core'
import { userInfoSource } from '~/store/user-info'

export const api = createPaywallApi({ userInfo: userInfoSource })
